import { greenvilleConfig } from "./data";
import CityPageTemplate from "../city-template/CityPageTemplate";

export default function GreenvillePage() {
  return <CityPageTemplate config={greenvilleConfig} />;
}